// CORE-1735 slice 17 (D-120, QA V06) — Live icon «search» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Circle, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Search: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Path d="M16 16l6 6" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
    <Circle cx={10} cy={10} r={7} fill="none" stroke={color} strokeWidth={1.8} />
    </G>
  </Svg>
);
